import { PlaybookIcon } from '@carboncopyco/icons';
import type { Playbook } from '@carboncopyco/types';
import { TooltipBubble } from '@carboncopyco/ui';
import { useCallback } from 'react';
import { SearchResultTile } from '../../../GridTiles';
import { useWorkspacePageProps } from '../WorkspacePageContext';
import { PlaybookActionsDropdown } from './EntitiesActionsDropdown/PlaybookActionsDropdown';

type PlaybookSearchResultTileProps = {
  playbook: Playbook;
  archived?: boolean;
  inFolder?: boolean;
};

export const PlaybookSearchResultTile = ({
  playbook,
  archived,
  inFolder,
}: PlaybookSearchResultTileProps) => {
  const { updateTime, name, id, totalPresentations } = playbook;
  const { goToPlaybook } = useWorkspacePageProps();

  const dropdown = useCallback(
    ({ toggleMenu }: { toggleMenu: () => void }) => {
      return (
        <PlaybookActionsDropdown
          archived={archived}
          handleMenuOpen={toggleMenu}
          playbook={playbook}
          inFolder={inFolder}
        />
      );
    },
    [playbook, archived, inFolder]
  );

  return (
    <SearchResultTile
      lastUpdated={updateTime}
      title={name}
      image=""
      isPlaybook
      totalPresentations={totalPresentations}
      onTileClick={archived ? undefined : () => goToPlaybook(id)}
      ActionDropdown={dropdown}
      icon={
        <TooltipBubble
          placement="top"
          title="Playbook"
        >
          <PlaybookIcon size={18} />
        </TooltipBubble>
      }
    />
  );
};
